/**
 * Avatar IDs and metadata
 * These correspond to avatar images that will be stored in R2 or public folder
 */
export const AVATARS = [
  { id: 'avatar_1', name: 'Gaming Controller', emoji: '🎮' },
  { id: 'avatar_2', name: 'Trophy', emoji: '🏆' },
  { id: 'avatar_3', name: 'Star', emoji: '⭐' },
  { id: 'avatar_4', name: 'Fire', emoji: '🔥' },
  { id: 'avatar_5', name: 'Rocket', emoji: '🚀' },
  { id: 'avatar_6', name: 'Crown', emoji: '👑' },
  { id: 'avatar_7', name: 'Diamond', emoji: '💎' },
  { id: 'avatar_8', name: 'Lightning', emoji: '⚡' },
  { id: 'avatar_9', name: 'Shield', emoji: '🛡️' },
  { id: 'avatar_10', name: 'Sword', emoji: '⚔️' },
  { id: 'avatar_11', name: 'Wizard', emoji: '🧙' },
  { id: 'avatar_12', name: 'Knight', emoji: '🤴' },
  { id: 'avatar_13', name: 'Ninja', emoji: '🥷' },
  { id: 'avatar_14', name: 'Robot', emoji: '🤖' },
  { id: 'avatar_15', name: 'Alien', emoji: '👽' },
  { id: 'avatar_16', name: 'Ghost', emoji: '👻' },
  { id: 'avatar_17', name: 'Dragon', emoji: '🐉' },
  { id: 'avatar_18', name: 'Unicorn', emoji: '🦄' },
  { id: 'avatar_19', name: 'Pirate', emoji: '🏴‍☠️' },
  { id: 'avatar_20', name: 'Astronaut', emoji: '👨‍🚀' },
] as const;

export type AvatarId = typeof AVATARS[number]['id'];

export function getAvatarById(id: string) {
  return AVATARS.find((avatar) => avatar.id === id);
}

export function getAvatarEmoji(id: string): string {
  return getAvatarById(id)?.emoji || '👤';
}


